import { render } from "./posmodal.vue?vue&type=template&id=6c4972ca&scoped=true"
import script from "./posmodal.vue?vue&type=script&lang=js"
export * from "./posmodal.vue?vue&type=script&lang=js"

import "./posmodal.vue?vue&type=style&index=0&id=6c4972ca&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4972ca"]])

export default __exports__